module.exports = __webpack_public_path__ + "static/media/500d.84a86102.jpg";